<!--  -->
<template>
    <div class="detail">
        <Header></Header>
        <div class="breadcrumb_box">
            <div class="breadcrumb">
                <span>研学基地</span>
                <div>></div>
                <span class="breadcrumb_name">{{$route.query.name}}</span>
            </div>
        </div>
        <div class="part1">
            <h1>{{$route.query.name}}</h1>
            <img class="line" src="../../assets/business/line.png" alt="">
            <div class="content">
                <video :src="downloadURLImg+video" controls v-if="video&&$route.query.id!=4"></video>
                <video src="../../assets/images/02.mp4" controls v-if="video&&$route.query.id==4"></video>
                <img :src="downloadURLImg+cover" alt="" v-if="!video">
                <div class="description">
                    <span class="title">简介</span>
                    <div class="text">{{ introduce }}</div>
                    <div class="label">
                        <span v-for="(item,index) in mark.split(',')" :key="index">#{{item}}#</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="part2">
            <div class="content">
                <div class="info">
                    <span class="title">路线图</span>
                    <div class="icon"></div>
                    <div class="item">
                        <img src="../../assets/business/icon06.png" alt="">
                        <span>地址:{{addr}}</span>
                    </div>
                    <div class="item">
                        <img src="../../assets/business/icon07.png" alt="">
                        <span>联系电话: {{phone}}</span>
                    </div>
                    <div class="item">
                        <img src="../../assets/business/icon08.png" alt="">
                        <span>联系人: {{contacts}}</span>
                    </div>
                    <div class="item">
                        <img src="../../assets/business/icon09.png" alt="">
                        <span>{{roadIntroduce}}</span>
                    </div>
                </div>
                <img class="path" :src="downloadURLImg+roadMap" alt="">
            </div>
        </div>
        <div class="part3" v-for="(item,index) in course" :key="index">
            <div class="content">
                <img :src="downloadURLImg+item.courseCover" alt="">
                <div class="description">
                    <span class="title">{{item.courseName}}</span>
                    <div class="text">{{ item.courseIntroduce }}</div>
                    <div class="label">
                        <span v-for="(items,index) in item.courseMark.split(',')" :key="index">#{{items}}#</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="part4">
            <span>感谢您的关注!如果您有任何想法，请填写如下内容告知我们您的需求，我们将尽快与您联系</span>
            <div class="input_box">
                <el-input v-model="mag_name" placeholder="姓名*"></el-input>
                <el-input v-model="msg_email" placeholder="邮箱*"></el-input>
                <el-input v-model="msg_phone" placeholder="电话*"></el-input>
                <el-input v-model="msg_addr" placeholder="地区*"></el-input>
                <el-input v-model="organizational" placeholder="单位机构*"></el-input>
            </div>
            <el-input type="textarea" :rows="5" placeholder="描述*" v-model="question">
            </el-input>
            <div class="btn" @click="submit">提交</div>
        </div>
        <!-- <Footer></Footer> -->
    </div>
</template>
<script>
    import Api from '../../config/api';

    export default {
        data() {
            return {
                input: '',
                textarea: '',
                course: [],
                introduce: '',
                cover: '',
                addr: '',
                phone: '',
                contacts: '',
                roadIntroduce: '',
                roadMap: '',
                mark: '',
                mag_name: '',
                msg_phone: '',
                msg_email: '',
                msg_addr: '',
                organizational: '',
                question: '',
                video:''
            }
        },
        methods: {
            getDetail() {
                let data = {
                    id: this.$route.query.id
                }
                Api.Home.GetAddressDetail(data)
                    .then(res => {
                        console.log('基地详情:', res);
                        this.introduce = res.data.introduce;
                        this.cover = res.data.cover;
                        this.addr = res.data.addr;
                        this.phone = res.data.phone;
                        this.contacts = res.data.contacts;
                        this.roadIntroduce = res.data.roadIntroduce;
                        this.roadMap = res.data.roadMap;
                        this.mark = res.data.mark;
                        this.course = res.data.course;
                        this.video = res.data.video
                    })
                    .catch(err => {
                        console.log('err:', err)
                    })
            },
            submit() {
                let data = {
                    baseId: this.$route.query.id,
                    name: this.mag_name,
                    phone: this.msg_phone,
                    email: this.msg_email,
                    addr: this.msg_addr,
                    organizational: this.organizational,
                    question: this.question
                }
                Api.Home.Message(data)
                    .then(res => {
                        console.log('留言成功:', res);
                        this.$message({
                            message: '留言成功',
                            type: 'success'
                        });
                    })
                    .catch(err => {
                        console.log('留言失败:', err);
                        this.$message.error('留言失败，请联系管理员');
                    })
            }
        },
        mounted() {
            this.getDetail()
        },
    };
</script>
<style lang='less' scoped>
    @import url('./less/detail.less');
</style>